import { z } from 'zod';

export const LeadPhoneNoteFormSchema = z
  .object({
    note: z.string(),
  })
  .superRefine((data, ctx: any) => {
    if (!data.note?.trim()) {
      ctx.addIssue({
        path: ['note'],
        message: 'Note is required',
        code: 'custom',
      });
    }
  });
